module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slowest.0b3be54e.svg";